export default {
  brand: "USFansLink.study",

  nav_home: "Accueil",
  nav_categories: "Catégories",
  nav_articles: "Guides",
  nav_visit: "Visiter le site principal",

  dropdown_label: "Parcourir les catégories",

  hero_eyebrow: "CENTRE DE RESSOURCES USFANS SPREADSHEET",
  hero_title: "USFans Spreadsheet : trouvez, comparez et explorez les ressources à jour",
  hero_subtitle:
    "Vous cherchez une façon plus claire d'explorer les ressources USFans spreadsheet ? USFansLink.study organise guides, avis, informations d'expédition, ressources d'entrepôt, coupons, comparaisons et informations de sécurité dans un hub facile à naviguer.",
  hero_cta_primary: "Explorer USFans Spreadsheet",
  hero_cta_secondary: "Lire le guide débutant",
  hero_trust: "Information indépendante • Guides pratiques • Ressources axées sécurité",

  search_title: "Rechercher les ressources USFans Spreadsheet",
  search_placeholder: "Rechercher USFans spreadsheet, expédition, entrepôt, avis ou coupons...",
  search_popular: "Recherches populaires",
  search_tags: ["USFans Spreadsheet", "USFans Avis", "USFans Frais de livraison", "USFans Coupon", "USFans Entrepôt", "USFans fiable ?"],

  topics_title: "Sujets populaires",
  topics_subtitle: "Commencez par le sujet qui compte le plus pour vous.",

  topic_1_title: "USFans Spreadsheet",
  topic_1_desc: "Explorez les ressources, catégories et guides de spreadsheet.",
  topic_2_title: "USFans Avis",
  topic_2_desc: "Comprenez la plateforme, ses fonctionnalités et points clés.",
  topic_3_title: "USFans Frais de livraison",
  topic_3_desc: "Découvrez ce qui influence les prix et comment comparer les options.",
  topic_4_title: "USFans Coupon",
  topic_4_desc: "Comprenez le fonctionnement des coupons et comment les vérifier.",
  topic_5_title: "USFans Entrepôt",
  topic_5_desc: "Comprenez le stockage, le traitement et les informations liées.",
  topic_6_title: "USFans fiable ?",
  topic_6_desc: "Apprenez à évaluer les signaux de confiance et à rester prudent.",

  value_title: "Tout ce qu'il faut pour comprendre les ressources USFans Spreadsheet",
  value_subtitle:
    "Les ressources USFans spreadsheet peuvent contenir des informations utiles, mais les trouver, les comparer et les vérifier peut être difficile. Notre objectif est d'organiser les sujets importants en guides pratiques et faciles à comprendre.",
  value_1_title: "DÉCOUVRIR",
  value_1_desc: "Trouvez des ressources USFans spreadsheet pertinentes.",
  value_2_title: "COMPARER",
  value_2_desc: "Comparez informations, options, coûts et fonctionnalités.",
  value_3_title: "VÉRIFIER",
  value_3_desc: "Apprenez à vérifier dates, liens, affirmations et informations tierces.",

  featured_title: "USFans Spreadsheet : votre point de départ",
  featured_subtitle:
    "Commencez par le hub USFans Spreadsheet pour explorer guides, catégories, comparaisons, FAQ et ressources à jour.",
  featured_cta: "Ouvrir le hub USFans Spreadsheet",

  compare_title: "Que recherchez-vous ?",
  compare_col_topic: "Sujet",
  compare_col_best: "Idéal pour",
  compare_col_info: "Information principale",
  compare_rows: [
    ["USFans Spreadsheet", "Découverte de ressources", "Listes, catégories et guides"],
    ["USFans Avis", "Recherche sur la plateforme", "Fonctionnalités et points clés"],
    ["Frais de livraison", "Recherche d'expédition", "Facteurs de coût et options"],
    ["Coupon", "Recherche d'offres", "Coupons et promotions"],
    ["Entrepôt", "Recherche d'entrepôt", "Stockage et traitement"],
    ["USFans fiable ?", "Recherche de confiance", "Vérification et sécurité"],
  ],

  trust_title: "Renseignez-vous avant de décider",
  trust_subtitle:
    "Les informations en ligne changent rapidement. Un spreadsheet, un coupon, une estimation d'expédition ou un lien tiers ne doit pas être considéré comme exact simplement parce qu'il apparaît en ligne. Vérifiez les dates, les informations importantes et utilisez des sources officielles pour les actions sensibles.",
  trust_cta: "Lire le guide sécurité",

  final_title: "Prêt à explorer les ressources USFans Spreadsheet ?",
  final_subtitle:
    "Commencez par le hub USFans Spreadsheet, explorez nos derniers guides et utilisez les informations pour prendre de meilleures décisions.",
  final_cta: "Explorer USFans Spreadsheet",
  final_secondary: "Visiter le site principal",

  btn_buy_now: "acheter maintenant",
  btn_usfans: "usfans spreadsheet",

  categories_title: "Parcourir toutes les catégories",
  categories_subtitle: "Accédez directement à la section qu'il vous faut sur le site principal.",

  articles_title: "Derniers guides USFans Spreadsheet",
  articles_subtitle: "Des guides originaux et utiles pour comprendre les ressources USFans.",
  article_1_title: "Qu'est-ce que USFans Spreadsheet ? Guide complet pour débutants",
  article_1_desc:
    "Une introduction claire et originale aux ressources USFans spreadsheet — ce qu'elles sont, comment elles aident et comment commencer en toute sécurité.",
  article_read: "Lire le guide",
  article_more: "Plus de guides à venir",
  article_related: "Guides associés",

  nav_shop_guide: "Guide d'achat",
  guide_eyebrow: "COMMENT ACHETER",
  guide_title: "Votre guide d'achat USFans",
  guide_intro:
    "Un guide simple, étape par étape, pour explorer les catégories USFans et finaliser votre commande sur le site officiel.",
  guide_steps_title: "Comment acheter en quatre étapes",
  guide_steps: [
    { title: "Choisissez une catégorie", desc: "Choisissez une catégorie comme les chaussures, les sweats ou les sacs." },
    { title: "Parcourez la sélection", desc: "Ouvrez la catégorie sur le site officiel et comparez les articles disponibles." },
    { title: "Vérifiez les détails", desc: "Confirmez le prix, la disponibilité, l'expédition et la livraison avant de décider." },
    { title: "Finalisez votre commande", desc: "Terminez le paiement en sécurité sur le site officiel et gardez une trace de votre commande." },
  ],
  guide_cta_title: "Prêt à commencer vos achats ?",
  guide_cta_desc: "Rendez-vous sur le site officiel et parcourez la gamme USFans à votre rythme.",
  guide_back_home: "Retour à l'accueil",

  footer_about: "USFansLink.study est une ressource d'information indépendante. Il n'est pas affilié à USFans ni à aucun service tiers mentionné sur ce site.",
  footer_disclaimer: "Les informations peuvent changer et doivent être vérifiées de façon indépendante.",
  footer_links: "Liens rapides",
  footer_categories: "Catégories",
  footer_rights: "Tous droits réservés.",

  cats: {
    shoes: "Chaussures",
    hoodies: "Sweats à capuche / Pulls",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons / Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
};